import { useUpdateUserSettings } from 'features/user';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Calendar, CheckCircle, Repeat } from 'shared/assets/icons';
import { Icon } from 'shared/components/ui/icon';
import {
  PopupMenu,
  PopupMenuList,
  PopupMenuListItem,
  PopupMenuToggle,
} from 'shared/components/ui/popup-menu';
import { useUser } from 'shared/hooks/use-user';

export type MainContextMenuProps = {
  referenceElement?: React.RefObject<HTMLElement>;
  onClose: () => void;
};

export const MainContextMenu: React.FC<MainContextMenuProps> = ({
  referenceElement,
  onClose,
}) => {
  const { t } = useTranslation();
  const user = useUser();

  const updateUserSettings = useUpdateUserSettings();
  const toggleHideExternalCalendarEvents = () =>
    updateUserSettings({
      upcoming: {
        hideExternalCalendarEvents:
          !user?.settings?.upcoming?.hideExternalCalendarEvents,
      },
    });
  const toggleHideHabits = () =>
    updateUserSettings({
      upcoming: {
        hideHabits: !user?.settings?.upcoming?.hideHabits,
      },
    });
  const toggleHideCompleted = () =>
    updateUserSettings({
      upcoming: {
        hideCompleted: !user?.settings?.upcoming?.hideCompleted,
      },
    });

  return (
    <PopupMenu
      referenceElement={referenceElement}
      position="bottom-end"
      onOutside={onClose}
    >
      <PopupMenuList hasBottomBorder>
        <PopupMenuListItem>
          <PopupMenuToggle
            start={<Icon icon={CheckCircle} />}
            label={t('pages.upcoming.show-completed.label')}
            onChange={toggleHideCompleted}
            checked={!user?.settings?.upcoming?.hideCompleted}
          />
        </PopupMenuListItem>
        <PopupMenuListItem>
          <PopupMenuToggle
            start={<Icon icon={Repeat} />}
            label={t('pages.upcoming.show-habits.label')}
            onChange={toggleHideHabits}
            checked={!user?.settings?.upcoming?.hideHabits}
          />
        </PopupMenuListItem>
        <PopupMenuListItem>
          <PopupMenuToggle
            start={<Icon icon={Calendar} />}
            label={t('pages.upcoming.show-external-calendars.label')}
            onChange={toggleHideExternalCalendarEvents}
            checked={!user?.settings?.upcoming?.hideExternalCalendarEvents}
          />
        </PopupMenuListItem>
      </PopupMenuList>
    </PopupMenu>
  );
};
